module.exports = __webpack_public_path__ + "media/assets/dashboard/inconector-0ea3335f2af9254311564dcecddf7256.png";